<footer>
    Copyright&#169 2022 Artsmith
</footer>

<style>
    footer{
        color: rgb(165, 165, 165);
        max-height: 60px;
        font-size: 0.9rem;
        text-align: center;
        padding: 5px;
        margin: 50px 30%;
        border-top: 1px solid rgb(165, 165, 165);
    }
</style>